import { ImWhatsapp } from 'react-icons/im';
import { FiMail, FiMessageSquare } from 'react-icons/fi';

import { ICustomRadioSelectorOption } from '~/shared/components/Form/CustomRadioSelector/types';

import { TSendUserPasswordRecoveryCodeMethod } from '../../interfaces/ISendUserPasswordRecoveryCodeRequest';

export const passwordRecoveryMethodsOptions: ICustomRadioSelectorOption<TSendUserPasswordRecoveryCodeMethod>[] =
  [
    {
      title: 'Whatsapp',
      description: 'O código será enviado por Whatsapp',
      value: 'whatsapp',
      icon: ImWhatsapp,
    },
    {
      title: 'E-mail',
      value: 'email',
      description: 'O código será enviado por e-mail',
      icon: FiMail,
    },
    {
      title: 'SMS',
      value: 'sms',
      description: 'O código será enviado por SMS',
      icon: FiMessageSquare,
    },
  ];
